'use client';

import React from 'react';
import AnalyticsTracker from './AnalyticsTracker';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export default function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  return (
    <AnalyticsTracker>
      {children}
    </AnalyticsTracker>
  );
}